var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.step == "1"
        ? _c("div", { staticClass: "login-title" }, [
            _c(
              "span",
              {
                staticClass: "item",
                class: { on: _vm.btnType === "person" },
                on: {
                  click: function($event) {
                    _vm.btnType = "person"
                  }
                }
              },
              [_vm._v("注册用户")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "line" }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "item",
                class: { on: _vm.btnType === "bus" },
                on: {
                  click: function($event) {
                    _vm.btnType = "bus"
                  }
                }
              },
              [_vm._v("企业邀请码注册")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step == "2"
        ? _c("div", { staticClass: "login-title" }, [
            _c("span", { staticClass: "item on" }, [_vm._v("企业邀请码注册")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.btnType === "person" ? _c("registerPerson") : _vm._e(),
      _vm._v(" "),
      _vm.btnType === "bus" && _vm.step == "1"
        ? _c("div", [
            _c("div", { staticClass: "login-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cstName,
                    expression: "cstName"
                  }
                ],
                attrs: { placeholder: "请输入企业名称", maxlength: "20" },
                domProps: { value: _vm.cstName },
                on: {
                  keyup: function($event) {
                    return _vm.checkInput("cstName")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cstName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cstNameErr && !_vm.cstName,
                      expression: "cstNameErr&&!cstName"
                    }
                  ],
                  staticClass: "login-err"
                },
                [_vm._v("企业名称不能为空")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "login-input-length" }, [
                _vm._v(_vm._s(_vm.cstName.length) + "/20")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "login-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cstOrgCode,
                    expression: "cstOrgCode"
                  }
                ],
                attrs: {
                  placeholder: "请输入企业的社会信用代码",
                  maxlength: "18"
                },
                domProps: { value: _vm.cstOrgCode },
                on: {
                  keyup: function($event) {
                    return _vm.checkInput("cstOrgCode")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cstOrgCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cstOrgCodeErr,
                      expression: "cstOrgCodeErr"
                    }
                  ],
                  staticClass: "login-err"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.cstOrgCode.length == 0
                        ? "社会信用代码不能为空"
                        : "不是有效的社会信用代码"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "login-input-length" }, [
                _vm._v(_vm._s(_vm.cstOrgCode.length) + "/18")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "login-input flexStart" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inviteCode,
                    expression: "inviteCode"
                  }
                ],
                staticStyle: { flex: "1", "margin-right": "30px" },
                attrs: {
                  placeholder: "请输入手机收到的邀请码",
                  maxlength: "6"
                },
                domProps: { value: _vm.inviteCode },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.login($event)
                  },
                  blur: function($event) {
                    return _vm.checkInput("inviteCode")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inviteCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("button-load", {
                    attrs: {
                      type: "primary",
                      disabled: _vm.countDisabled,
                      lable:
                        _vm.counter > 0
                          ? _vm.counter + "s&nbsp;后重新获取"
                          : "重新获取"
                    },
                    on: { clickHandle: _vm.getInviteCode }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inviteCodeErr && _vm.inviteCode.length != 6,
                      expression: "inviteCodeErr&&inviteCode.length!=6"
                    }
                  ],
                  staticClass: "login-err"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.inviteCode.length == 0
                        ? "邀请码不能为空"
                        : "请输入6位邀请码"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "login-input-length",
                  staticStyle: { right: "156px" }
                },
                [_vm._v(_vm._s(_vm.inviteCode.length) + "/6")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "login-input" },
              [
                _c(
                  "a-checkbox",
                  {
                    staticStyle: { color: "#1890ff" },
                    model: {
                      value: _vm.isAgree,
                      callback: function($$v) {
                        _vm.isAgree = $$v
                      },
                      expression: "isAgree"
                    }
                  },
                  [_vm._v("同意")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticStyle: { color: "#999" },
                    on: { click: _vm.showModal }
                  },
                  [_vm._v("《告知书》")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "text-color-red text-size-12",
                staticStyle: { position: "absolute" }
              },
              [_vm._v(_vm._s(_vm.errMsg))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "login-btn-box" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "login-btn",
                    attrs: {
                      loading: _vm.loadLogin,
                      type: "primary",
                      disabled: !_vm.checkInput()
                    },
                    on: { click: _vm.checkRegister }
                  },
                  [_vm._v("注册")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "login-register" }, [
                  _c("span", { on: { click: _vm.toRegister } }, [
                    _vm._v("登 录")
                  ])
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.btnType === "bus" && _vm.step == "2"
        ? _c("div", { staticClass: "step-2" }, [_c("register-save")], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49bf95da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49bf95da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/register.vue
// module id = ePc5
// module chunks = 1